import styled from 'styled-components';

export const StyledDcaWrapper = styled.div`
  display: contents !important;
  width: 100% !important;
  height: 100% !important;

  & > div {
    width: inherit;
    height: inherit;
  }
`;
